'use strict';

define('controllers/abortingRequest',['jquery', 'context', 'models/userIdentityModel', 'store/tokenStore', 'helpers/accessTokenHelper', 'routing/mainRouter', 'messenger'], function (jquery, context, userIdentityModel, tokenStore, accessTokenHelper, mainRouter, messenger) {

	var pendingRequests = {};
	var isRefreshingToken = false;

	function AbortingRequest() {}

	var replayAllPending = function replayAllPending() {
		isRefreshingToken = false;

		for (var property in pendingRequests) {
			if (pendingRequests.hasOwnProperty(property)) {

				var pendingRequest = pendingRequests[property];
				pendingRequest.options.settings.headers.Authorization = 'Bearer ' + tokenStore.getAccessToken();
				this.send(property, pendingRequest.options, pendingRequest.allowMultiple, pendingRequest.abortable).done(pendingRequest.deferred.resolve).fail(pendingRequest.deferred.reject);
			}
		}
	};

	var rejectAllPending = function rejectAllPending() {
		isRefreshingToken = false;

		for (var property in pendingRequests) {
			if (pendingRequests.hasOwnProperty(property)) {

				var pendingRequest = pendingRequests[property];
				pendingRequest.deferred.reject({ status: pendingRequest.status });
			}
		}
	};

	var logout = function logout() {

		userIdentityModel.clear();

		tokenStore.clearAccessToken();

		messenger.trigger('identity:logout');
	};

	AbortingRequest.prototype.abortAll = function () {
		for (var property in pendingRequests) {
			if (pendingRequests.hasOwnProperty(property)) {
				if (pendingRequests[property].abortable === false) {
					continue;;
				}

				pendingRequests[property].abort();
			}
		}
		pendingRequests = {};
	};

	AbortingRequest.prototype.send = function (url, options, allowMultiple, abortable) {
		var _this = this;

		var deferred = jquery.Deferred();

		options.refreshTokePromise.then(function () {

			if (options.settings && options.settings.headers) {
				options.settings.headers.version = context.applicationVersion;
			}

			var pendingRequest = pendingRequests[url];
			if (pendingRequest && !allowMultiple) {
				pendingRequest.abort();
			}

			var xhr = jquery.ajax(jquery.extend({
				url: url,
				error: function (result, status) {
					if (result.status === 401) {
						if (isRefreshingToken === false) {
							isRefreshingToken = true;
							accessTokenHelper.refreshAccessToken().done(replayAllPending.bind(this)).fail(function (response) {
								rejectAllPending();

								if (response && (response.errorCode === 'TokenInvalid' || response.errorCode === 'TokenNotExist' || response.errorCode === 'TokenUsed' || response.errorCode === 'WrongUser' || response.errorCode === 'TokenNotMatch')) {
									logout();
								}
							}.bind(this));
							//.fail(logout.bind(this));
						}
					} else {
						if (status !== 'abort') {
							delete pendingRequests[url];
						}
						deferred.reject(result);
					}
				}.bind(_this)
			}, options.settings));

			xhr.abortable = abortable;
			xhr.allowMultiple = allowMultiple;
			xhr.options = options;
			xhr.deferred = deferred;

			pendingRequests[url] = xhr;

			xhr.always(function (result, status, xhr) {

				if (xhr.getResponseHeader && xhr.getResponseHeader('version-conflict') === '1') {
					window.location.reload(true);
				}

				if (xhr.getResponseHeader && xhr.getResponseHeader('version-conflict') === '2') {
					logout();

					window.location.reload(true);
				}
			});

			xhr.done(function (result) {
				delete pendingRequests[url];
				deferred.resolve(result);
			});

			var abortingRequestPromise = deferred.promise();
			abortingRequestPromise.abort = function () {
				xhr.abort();
			};

			//return abortingRequestPromise;
		}.bind(_this));

		return deferred.promise();
	};

	return new AbortingRequest();
});
